import {Component, Input} from '@angular/core';
import {CustomModalModel} from '../../../../../core-logic/models/custom-modal/custom-modal-model';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'app-custom-modal',
  templateUrl: './custom-modal.component.html',
  styleUrls: ['./custom-modal.component.scss']
})
export class CustomModalComponent {
  @Input() customModalModel: CustomModalModel;
  constructor(private modalCtrl: ModalController) { }

  cancel() { this.modalCtrl.dismiss({validate: false}); }

  validate() { this.modalCtrl.dismiss({validate: true}); }
}
